import { useMemo } from "react";

import { Destination, FormField } from "@prequel/react";
import { Dropdown } from "@prequel/shared-components";

import { WrapperProps } from "..";

import VendorLogo from "@/components/VendorLogo";
import { MagicLink } from "@/types";
import { Source } from "@/types/sources";
import { SourceFormField } from "@/types/sources/form";

type SelectWrapperProps<
  F extends FormField | SourceFormField,
  C extends Destination | Source | MagicLink,
> = WrapperProps<F & { form_element: "select" }, C>;
const SelectWrapper = <F extends FormField | SourceFormField, C extends Destination | Source | MagicLink>({
  field,
  connection,
  setConnectionField,
  disabled,
  isEditing,
}: SelectWrapperProps<F, C>) => {
  const items = useMemo(
    () =>
      field.enum?.map((e) => ({
        key: e.key.toString(),
        text: e.display,
        ...(e.icon_url !== undefined ? { icon: () => <VendorLogo logo_url={e.icon_url ?? ""} /> } : {}),
      })),
    [field.enum],
  );

  const fieldName = field.name;
  const connectionValue = connection[fieldName];
  const selected = useMemo(() => items?.find(({ key }) => key === connectionValue), [items, connectionValue]);

  return (
    <Dropdown
      label={field.label}
      items={items ?? []}
      selectedItem={selected}
      setSelectedItem={(item) => setConnectionField(field.name as keyof C, item.key)}
      disabled={disabled || (field.name === "vendor" && isEditing) || items?.length === 0}
    />
  );
};

export default SelectWrapper;
